export function createDispatchOperationsReadModelClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * List dispatches, live by default, soonest deadline first
         *
         * Requires scope: dispatch-operations:read
         */
        listDispatchOperations(tenantId, status, live, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-operations`,
                query: { status: status, live: live, limit: limit, after: after },
                options,
            });
        },
        /**
         * What is known about one dispatch
         *
         * Requires scope: dispatch-operations:read
         */
        getDispatchOperation(tenantId, demandId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-operations/${encodeURIComponent(demandId)}`,
                options,
            });
        },
        /**
         * Fold one dispatch lifecycle event into the projection
         *
         * Requires scope: dispatch-operations:project
         */
        projectDispatchEvent(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-events`,
                body,
                options,
            });
        },
        /**
         * Discard this tenant's projection so it can be rebuilt
         *
         * Requires scope: dispatch-operations:rebuild
         */
        resetDispatchProjection(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-operations/reset`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=dispatch-operations-read-model.js.map